import { Box, Flex } from "@chakra-ui/react";
import Sidebar from "../sidebar";

const MainLayout = ({children}) => {
  return (
    <Flex minH={"100vh"}>
      <Sidebar />
      <Box flex={1} ml={"280px"}>
        {children}
      </Box>
    </Flex>
  );
};

export default MainLayout;
